const SITE_ORIGIN = "https://casadata.io";

const makeUrl = (path) => `${SITE_ORIGIN}${path === "/" ? "/" : path}`;

const languageLabel = {
  "es-PR": "Spanish",
  "en-US": "English"
};

const pricing = {
  base: 0,
  pass72: 12.99,
  plusMaxMonthly: 19.99,
  plusMaxYearly: 119.99,
  plusMaxProMonthly: 49.99,
  plusMaxProYearly: 499
};

const plusMaxSavingsPct = Math.round(100 - (pricing.plusMaxYearly / (pricing.plusMaxMonthly * 12)) * 100);

const featureProofItems = [
  "Ventas cerradas de propiedades en Puerto Rico.",
  "Comparables residenciales, multifamiliares, solares y comerciales.",
  "Filtros por municipio, zona, precio, fecha de venta, tamano de estructura y tamano de terreno.",
  "Datos de comprador y vendedor para usuarios PlusMAX.",
  "Contexto de CRIM/catastro y estimado mensual de contribucion cuando los datos estan disponibles.",
  "Enlaces a escrituras, recibos o documentos disponibles cuando existen en la propiedad.",
  "Historial documental y transaccional disponible cuando la fuente lo provee.",
  "Marcadores de propiedades reposeidas y refinanciadas.",
  "Indicador de zonas inundables.",
  "Estimado de valor, estimado de equidad, precio por pie cuadrado, tendencias, rangos y liquidez.",
  "Mapa interactivo, seleccion de areas y herramientas de analisis estadistico.",
  "Exportacion CSV compatible con Excel para analisis profesional.",
  "Soporte y experiencia de uso en espanol e ingles."
];

const plusMaxItems = [
  "Precios y fechas de venta.",
  "Tamanos de estructura y terreno.",
  "Busquedas ilimitadas.",
  "Filtros por precio, tamano y fecha de venta.",
  "Estimado de valor y equidad.",
  "Herramientas de analisis estadistico.",
  "Exportacion CSV compatible con Excel.",
  "Datos de comprador y vendedor.",
  "Marcadores de propiedades reposeidas y refinanciadas.",
  "Indicador de zonas inundables.",
  "Estimado mensual de contribucion CRIM.",
  "Documentos o escrituras disponibles cuando existan."
];

const coreFaqs = [
  {
    question: "CASADATA reemplaza una tasacion formal?",
    answer: "No. CASADATA ayuda a organizar evidencia de mercado y comparables, pero una tasacion formal debe realizarla un profesional autorizado cuando aplique."
  },
  {
    question: "Que diferencia hay entre ventas cerradas y listados activos?",
    answer: "Los listados activos muestran precios pedidos. Las ventas cerradas muestran transacciones completadas y ayudan a entender lo que el mercado realmente pago."
  },
  {
    question: "CASADATA incluye escrituras?",
    answer: "CASADATA muestra referencias, recibos o documentos de escritura cuando estan disponibles para la propiedad correspondiente."
  },
  {
    question: "CASADATA incluye datos de CRIM?",
    answer: "Si. CASADATA incluye contexto de CRIM/catastro y estimados de contribuciones cuando los datos estan disponibles."
  },
  {
    question: "Puedo exportar los datos?",
    answer: "Si. Los planes pagos incluyen exportacion CSV compatible con Excel segun el nivel de acceso."
  },
  {
    question: "CASADATA muestra zonas inundables?",
    answer: "Si. CASADATA incluye alertas de inundabilidad para ayudar a identificar riesgo de ubicacion."
  }
];

const planArticles = [
  {
    heading: "Gratis / Base",
    body: [
      `Acceso base para explorar CASADATA y validar el flujo antes de activar herramientas premium. Precio: $${pricing.base}.`
    ]
  },
  {
    heading: "Pase 72h",
    body: [
      `Acceso de 72 horas por $${pricing.pass72} más IVU. Es un pago único, no recurrente.`
    ],
    items: [
      "Precios y fechas de venta, tamaños, estimados de valor/equidad, CRIM, inundabilidad y repos/refis.",
      "No incluye comprador/vendedor, exportación CSV, chat LLM ni documentos Karibe."
    ]
  },
  {
    heading: "PlusMAX mensual",
    body: [
      `Acceso completo por $${pricing.plusMaxMonthly}/mes mas IVU. Incluye comparables, mapas, analisis avanzado, datos adicionales y exportacion.`
    ],
    items: plusMaxItems
  },
  {
    heading: "PlusMAX anual",
    body: [
      `Acceso completo por $${pricing.plusMaxYearly}/ano mas IVU. Equivale a $${(pricing.plusMaxYearly / 12).toFixed(2)}/mes y ahorra aproximadamente ${plusMaxSavingsPct}% frente al pago mensual.`
    ],
    items: ["Misma funcionalidad de PlusMAX mensual.", "Facturacion anual recurrente.", "Cancelacion disponible desde la cuenta."]
  },
  {
    heading: "PlusMAX Pro",
    body: [
      `El nivel superior para profesionales: $${pricing.plusMaxProMonthly}/mes o $${pricing.plusMaxProYearly}/año, más IVU. Incluye todo lo de PlusMAX.`
    ],
    items: [
      "Todo lo de PlusMAX incluido: comprador/vendedor, exportación CSV, búsquedas ilimitadas, reposeídas, CRIM e inundabilidad.",
      "Exclusivo de Pro: informe PDF de comparables con tu nombre y marca.",
      "Exclusivo de Pro: historial de informes.",
      "Exclusivo de Pro: áreas guardadas con resumen al iniciar sesión.",
      "Exclusivo de Pro: chat de análisis con IA sobre tus datos."
    ]
  }
];

const plansSection = {
  id: "planes",
  heading: "Planes de CASADATA",
  body: [
    "Empieza con acceso base, activa un Pase 72h de pago único, suscríbete a PlusMAX para acceso completo o elige PlusMAX Pro con herramientas de informe y análisis para profesionales.",
    "Los precios reflejan la estructura actual de la aplicación y pueden estar sujetos a IVU."
  ],
  articles: planArticles
};

const founderSection = {
  id: "precio-fundador",
  heading: "Precio fundador PlusMAX",
  body: [
    "El precio fundador esta reservado para los primeros espacios de esta etapa. Los miembros activos conservan este acceso mientras su suscripcion permanezca vigente.",
    "Al completarse este lote, CASADATA abrira su proxima etapa de acceso con una nueva estructura de precios."
  ]
};

const limitationSection = {
  id: "limitaciones",
  heading: "Limitaciones importantes",
  body: [
    "CASADATA no reemplaza una tasacion formal, estudio de titulo, mensura, certificacion de zonificacion ni asesoramiento legal.",
    "La plataforma organiza datos disponibles para analisis y toma de decisiones; cualquier asunto legal, registral, contributivo u oficial debe validarse con el profesional o entidad correspondiente."
  ]
};

const createTopicPair = ({
  slug,
  priority = 0.85,
  esPath,
  enPath,
  es,
  en
}) => {
  const alternates = {
    "es-PR": esPath,
    "en-US": enPath,
    "x-default": esPath
  };

  return [
    {
      ...es,
      slug: `${slug}-es`,
      kind: "topic",
      path: esPath,
      language: "es-PR",
      priority,
      alternates
    },
    {
      ...en,
      slug: `${slug}-en`,
      kind: "topic",
      path: enPath,
      language: "en-US",
      priority,
      alternates
    }
  ];
};

const makeSpanishPage = ({
  slug,
  path,
  title,
  description,
  eyebrow = "CASADATA PUERTO RICO",
  h1,
  intro,
  sections,
  faqs = [],
  priority = 0.75,
  includeOfferCatalog = false,
  primaryCta = "Ver planes",
  secondaryCta = "Abrir CASADATA",
  primaryHref = "/planes",
  secondaryHref = "/?go=prices",
  alternates
}) => ({
  slug,
  kind: "topic",
  path,
  language: "es-PR",
  priority,
  alternates: alternates || {
    "es-PR": path,
    "x-default": path
  },
  title,
  description,
  eyebrow,
  h1,
  intro,
  sections,
  faqs,
  includeOfferCatalog,
  primaryCta,
  secondaryCta,
  primaryHref,
  secondaryHref
});

const makeEnglishPage = ({
  slug,
  path,
  title,
  description,
  eyebrow = "CASADATA PUERTO RICO",
  h1,
  intro,
  sections,
  faqs = [],
  priority = 0.74,
  includeOfferCatalog = false,
  primaryCta = "Open CASADATA",
  secondaryCta = "View plans",
  primaryHref = "/?go=prices",
  secondaryHref = "/planes",
  alternates
}) => ({
  slug,
  kind: "topic",
  path,
  language: "en-US",
  priority,
  alternates: alternates || {
    "en-US": path,
    "x-default": path
  },
  title,
  description,
  eyebrow,
  h1,
  intro,
  sections,
  faqs,
  includeOfferCatalog,
  primaryCta,
  secondaryCta,
  primaryHref,
  secondaryHref
});

const corePages = [
  {
    slug: "home",
    kind: "landing",
    path: "/",
    language: "es-PR",
    priority: 1,
    includeOfferCatalog: true,
    alternates: {
      "es-PR": "/",
      "x-default": "/"
    },
    title: "CASADATA | Comparables y ventas cerradas en Puerto Rico",
    description: "Compara ventas cerradas, mapas, CRIM, documentos disponibles, riesgos y exportaciones para analizar propiedades en Puerto Rico.",
    eyebrow: "VENTAS HISTORICAS Y COMPARABLES DE PUERTO RICO",
    h1: "Comparables de ventas cerradas en Puerto Rico",
    intro: [
      "CASADATA ayuda a compradores, vendedores, corredores, tasadores e inversionistas a analizar ventas cerradas reales en Puerto Rico con comparables, mapas, datos de comprador y vendedor, CRIM/catastro, escrituras disponibles, alertas de inundabilidad y herramientas de valoracion.",
      "Puerto Rico's closed-sale comparable intelligence platform for buyers, sellers, Realtors, appraisers, and investors."
    ],
    sections: [
      {
        id: "que-incluye",
        heading: "Que incluye CASADATA",
        body: [
          "La plataforma expone datos y herramientas que ayudan a convertir transacciones dispersas en evidencia util para compra, venta, tasacion, corretaje e inversion."
        ],
        items: featureProofItems
      },
      plansSection,
      founderSection,
      {
        heading: "Datos para decisiones de precio",
        body: [
          "Usa ventas cerradas y propiedades similares para defender rangos de valor, preparar conversaciones con clientes y reducir dependencia en listados activos.",
          "El flujo esta disenado para comparar municipio, zona, tamano, fecha, precio y tipo de propiedad con menos trabajo manual."
        ]
      },
      {
        heading: "Cobertura local",
        body: [
          "CASADATA esta enfocado en Puerto Rico: municipios, transacciones, propiedades reposeidas, propiedades refinanciadas, contexto CRIM y herramientas utiles para profesionales locales."
        ]
      },
      limitationSection
    ],
    faqs: coreFaqs,
    primaryCta: "Ver planes y acceso",
    secondaryCta: "Abrir CASADATA",
    primaryHref: "/planes",
    secondaryHref: "/?go=prices"
  },
  {
    slug: "planes",
    kind: "topic",
    path: "/planes",
    language: "es-PR",
    priority: 0.94,
    includeOfferCatalog: true,
    alternates: {
      "es-PR": "/planes",
      "x-default": "/planes"
    },
    title: "Planes CASADATA | Comparables desde $19.99/mes",
    description: "Planes de CASADATA para analizar comparables, ventas cerradas, CRIM, documentos disponibles, riesgos y datos de mercado en Puerto Rico.",
    eyebrow: "PLANES DE CASADATA",
    h1: "Planes de CASADATA para analizar comparables en Puerto Rico",
    intro: [
      "Elige el nivel de acceso que necesitas para analizar ventas cerradas, comparables, mapas, CRIM/catastro, riesgos y exportaciones.",
      "PlusMAX es el acceso completo actual para usuarios que necesitan analisis profesional de propiedades en Puerto Rico."
    ],
    sections: [
      plansSection,
      {
        heading: "Que incluye PlusMAX",
        body: [
          "PlusMAX desbloquea el conjunto completo de herramientas premium que el producto muestra en la aplicacion."
        ],
        items: plusMaxItems
      },
      founderSection,
      limitationSection
    ],
    faqs: coreFaqs,
    primaryCta: "Activar PlusMAX",
    secondaryCta: "Comparar funciones",
    primaryHref: "/?go=prices&src=seo_planes",
    secondaryHref: "/es/casadata-vs-comparables-puerto-rico"
  },
  {
    slug: "realtor",
    kind: "landing",
    path: "/realtor",
    language: "es-PR",
    priority: 0.9,
    alternates: {
      "es-PR": "/realtor",
      "x-default": "/realtor"
    },
    title: "CASADATA para Corredores | Comparables Puerto Rico",
    description: "Prepara captaciones, sustenta precios y valida ofertas con ventas cerradas, mapas, CRIM, documentos disponibles y exportaciones.",
    eyebrow: "PARA CORREDORES Y BROKERS",
    h1: "CASADATA para corredores y brokers en Puerto Rico",
    intro: [
      "Prepara conversaciones de captacion, sustenta precios de listado y valida ofertas con comparables de ventas cerradas, datos CRIM, escrituras disponibles cuando existan, mapas y exportaciones profesionales.",
      "CASADATA reduce investigacion manual para que el corredor pueda orientar mejor al cliente desde la primera reunion hasta el cierre."
    ],
    sections: [
      {
        heading: "Como ayuda a corredores",
        items: [
          "Comparar ventas cerradas mas alla de portales de listados.",
          "Defender rangos de precio con evidencia.",
          "Identificar propiedades reposeidas, refinanciadas o inundables.",
          "Exportar datos para presentaciones y analisis.",
          "Apoyar conversaciones con compradores, vendedores o captaciones."
        ]
      },
      {
        heading: "Captacion y pricing",
        body: [
          "Prepara CMAs con comparables mas claros, valida rangos de mercado y explica al dueno por que un precio es defendible."
        ]
      },
      limitationSection
    ],
    faqs: coreFaqs.slice(0, 4),
    primaryCta: "Ver planes para corredores",
    secondaryCta: "Contactar ventas",
    primaryHref: "/planes",
    secondaryHref: "/?go=contact"
  },
  {
    slug: "tasadores",
    kind: "landing",
    path: "/tasadores",
    language: "es-PR",
    priority: 0.9,
    alternates: {
      "es-PR": "/tasadores",
      "x-default": "/tasadores"
    },
    title: "CASADATA para Tasadores | Comparables Puerto Rico",
    description: "Compara ventas cerradas, datos de transaccion, CRIM, documentos disponibles, mapas y exportaciones para apoyar analisis.",
    eyebrow: "COMPARABLES PARA TASADORES",
    h1: "CASADATA para tasadores en Puerto Rico",
    intro: [
      "Accede a comparables de ventas cerradas, datos de transaccion, CRIM/catastro, documentos disponibles, mapas y exportaciones para apoyar analisis de mercado y seleccion de comparables.",
      "La plataforma organiza evidencia y criterios visibles para revision, archivo y defensa tecnica."
    ],
    sections: [
      {
        heading: "Soporte para analisis de comparables",
        items: [
          "Ventas cerradas por municipio, zona, fecha, precio y tamano.",
          "Datos de comprador, vendedor, escritura y documentos disponibles cuando existan.",
          "Precio por pie cuadrado, mediana, promedio y rango.",
          "Marcadores de riesgo como inundabilidad, reposeidas y refinanciadas.",
          "Exportacion CSV compatible con Excel para analisis profesional."
        ]
      },
      limitationSection
    ],
    faqs: coreFaqs,
    primaryCta: "Explorar planes para tasadores",
    secondaryCta: "Solicitar orientacion",
    primaryHref: "/planes",
    secondaryHref: "/?go=contact"
  },
  {
    slug: "inversionistas",
    kind: "landing",
    path: "/inversionistas",
    language: "es-PR",
    priority: 0.9,
    alternates: {
      "es-PR": "/inversionistas",
      "x-default": "/inversionistas"
    },
    title: "CASADATA para Inversionistas | Puerto Rico",
    description: "Evalua oportunidades con ventas cerradas, valor, equidad, CRIM, documentos disponibles, reposeidas, refinanciadas y riesgos.",
    eyebrow: "PARA INVERSIONISTAS",
    h1: "CASADATA para inversionistas en Puerto Rico",
    intro: [
      "Evalua oportunidades de compra con ventas cerradas reales, estimados de valor, equidad, datos de CRIM, documentos disponibles, marcadores de reposeidas/refinanciadas e inundabilidad.",
      "Usa comparables, ventas cerradas y contexto local para separar oportunidades reales de propiedades que solo consumen tiempo."
    ],
    sections: [
      {
        heading: "Antes de invertir, valida el mercado",
        items: [
          "Compara el precio de compra contra ventas cerradas cercanas.",
          "Detecta senales de riesgo y contexto documental disponible.",
          "Estima valor, equidad y rango de mercado.",
          "Exporta datos para analisis financiero."
        ]
      },
      limitationSection
    ],
    faqs: coreFaqs.slice(0, 4),
    primaryCta: "Ver planes para inversionistas",
    secondaryCta: "Hablar con un especialista",
    primaryHref: "/planes",
    secondaryHref: "/?go=contact"
  }
];

const topicPages = [
  ...createTopicPair({
    slug: "comparables",
    esPath: "/es/comparables-puerto-rico",
    enPath: "/en/puerto-rico-property-comps",
    es: {
      title: "Comparables Puerto Rico | Ventas cerradas",
      description: "Encuentra comparables de ventas reales en Puerto Rico con mapas, filtros, datos CRIM, documentos disponibles y exportacion.",
      eyebrow: "COMPARABLES PUERTO RICO",
      h1: "Comparables de ventas cerradas en Puerto Rico",
      intro: [
        "CASADATA organiza ventas cerradas, filtros y contexto de mapa para que puedas comparar propiedades similares y defender rangos de valor con evidencia.",
        "La plataforma ayuda a compradores, vendedores, corredores, tasadores e inversionistas a evaluar propiedades con datos reales."
      ],
      sections: [
        { heading: "Que puedes comparar", items: featureProofItems },
        {
          heading: "Por que usar ventas cerradas",
          body: [
            "Los listados activos muestran aspiracion de precio. Las ventas cerradas muestran lo que el mercado realmente acepto.",
            "Con CASADATA puedes acotar por area, fecha, tipo de propiedad, precio y tamano para encontrar comps mas utiles."
          ]
        },
        limitationSection
      ],
      faqs: coreFaqs,
      primaryCta: "Probar comparables en CASADATA",
      secondaryCta: "Ver planes",
      primaryHref: "/?go=prices&src=seo_comparables",
      secondaryHref: "/planes"
    },
    en: {
      title: "Puerto Rico Property Comps | Closed Sales",
      description: "Find Puerto Rico property comps with closed sales, map filters, CRIM context, available documents, and exports.",
      eyebrow: "PUERTO RICO PROPERTY COMPS",
      h1: "Puerto Rico property comps from closed sales",
      intro: [
        "CASADATA helps buyers, sellers, agents, appraisers, and investors compare closed sales with map-based filters and local context.",
        "The platform is built for Puerto Rico market analysis, comparable selection, and professional export workflows."
      ],
      sections: [
        {
          heading: "What CASADATA helps compare",
          items: [
            "Closed sales in Puerto Rico.",
            "Residential, multifamily, land, and commercial comparables.",
            "Municipality, area, price, sale date, structure size, and land size filters.",
            "Buyer and seller data for PlusMAX users.",
            "CRIM/cadastre context and monthly property tax estimates when available.",
            "Available deed or document links when they exist.",
            "Repossessed, refinanced, and flood-zone indicators.",
            "Value estimate, equity estimate, price per square foot, trends, ranges, and liquidity.",
            "CSV export compatible with Excel."
          ]
        },
        {
          heading: "Why closed sales matter",
          body: [
            "Active listings show asking prices. Closed sales show what the market actually accepted.",
            "CASADATA lets you narrow by area, date, property type, price, and size to build a more defensible comp set."
          ]
        }
      ],
      faqs: [
        { question: "Does CASADATA provide an official appraisal?", answer: "No. CASADATA organizes market evidence and comparable data; formal appraisals should be completed by licensed professionals." },
        { question: "Can I export the data?", answer: "Yes. Paid plans include CSV export compatible with Excel according to the access level." }
      ],
      primaryCta: "Try CASADATA comps",
      secondaryCta: "View plans",
      primaryHref: "/?go=prices&src=seo_comps_en",
      secondaryHref: "/planes"
    }
  }),
  ...createTopicPair({
    slug: "closed-sales",
    priority: 0.82,
    esPath: "/es/ventas-cerradas-puerto-rico",
    enPath: "/en/puerto-rico-real-estate-sales-data",
    es: {
      title: "Ventas cerradas Puerto Rico | Datos de mercado",
      description: "Analiza ventas cerradas en Puerto Rico para entender precios reales, tendencias, liquidez y comparables por municipio.",
      eyebrow: "VENTAS CERRADAS",
      h1: "Ventas cerradas en Puerto Rico para analizar el mercado",
      intro: [
        "Las ventas cerradas son una de las mejores senales para entender el valor real de una propiedad en Puerto Rico.",
        "CASADATA permite explorar transacciones historicas, filtrar por zona y detectar tendencias que no siempre aparecen en portales de listados."
      ],
      sections: [
        {
          heading: "Que revelan las ventas cerradas",
          body: [
            "Muestran precio aceptado, actividad por fecha, comportamiento de municipios y diferencias entre tipos de propiedad.",
            "Tambien ayudan a identificar ventas atipicas, mercados con poca liquidez y zonas donde el precio cambia rapido."
          ]
        },
        { heading: "Datos disponibles", items: featureProofItems },
        limitationSection
      ],
      faqs: coreFaqs,
      primaryCta: "Analizar ventas cerradas",
      secondaryCta: "Ver planes",
      primaryHref: "/?go=prices&src=seo_ventas",
      secondaryHref: "/planes"
    },
    en: {
      title: "Puerto Rico Real Estate Sales Data",
      description: "Analyze Puerto Rico real estate sales data, closed sales, comps, trends, and market context with CASADATA.",
      eyebrow: "REAL ESTATE SALES DATA",
      h1: "Puerto Rico real estate sales data for market analysis",
      intro: [
        "Closed sales are one of the strongest signals for understanding real property value in Puerto Rico.",
        "CASADATA helps users explore historical transactions, filter by area, and identify market patterns that listing portals often miss."
      ],
      sections: [
        {
          heading: "What closed sales reveal",
          body: [
            "Closed sales reveal accepted price, activity by period, municipal behavior, and differences across property types.",
            "They also help identify outliers, low-liquidity areas, and neighborhoods where pricing changes quickly."
          ]
        }
      ],
      faqs: [
        { question: "Why not rely only on active listings?", answer: "An active listing is an asking price. A closed sale confirms a price accepted by buyer and seller." },
        { question: "Can I filter sales by date?", answer: "Yes. CASADATA supports date filtering so users can separate recent evidence from older data." }
      ],
      primaryCta: "Analyze closed sales",
      secondaryCta: "View plans",
      primaryHref: "/?go=prices&src=seo_sales_en",
      secondaryHref: "/planes"
    }
  }),
  ...createTopicPair({
    slug: "home-value",
    priority: 0.9,
    esPath: "/es/cuanto-vale-mi-casa-puerto-rico",
    enPath: "/en/puerto-rico-home-values",
    es: {
      title: "Cuanto vale mi casa en Puerto Rico",
      description: "Estima valor con ventas cerradas, comparables, precio por pie cuadrado, CRIM, riesgos y tendencias de mercado.",
      eyebrow: "VALOR DE PROPIEDAD",
      h1: "Cuanto vale mi casa en Puerto Rico",
      intro: [
        "CASADATA ayuda a estimar el valor de una propiedad en Puerto Rico usando comparables de ventas cerradas, precio por pie cuadrado, tendencias de mercado, tamano de estructura, tamano de solar, municipio, barrio y datos de transacciones reales."
      ],
      sections: [
        {
          heading: "Por que usar ventas cerradas",
          body: [
            "Los precios de listado muestran lo que alguien pide. Las ventas cerradas muestran lo que compradores y vendedores realmente aceptaron en transacciones completadas."
          ]
        },
        {
          heading: "Que analiza CASADATA",
          items: [
            "Ventas recientes cercanas.",
            "Propiedades similares por tamano, tipo y localizacion.",
            "Precio por pie cuadrado.",
            "Rango probable de valor.",
            "CRIM/catastro y contribucion estimada.",
            "Alertas de inundabilidad, reposeidas y refinanciadas."
          ]
        },
        limitationSection
      ],
      faqs: coreFaqs,
      primaryCta: "Estimar valor con datos",
      secondaryCta: "Ver planes",
      primaryHref: "/?go=prices&src=seo_valor",
      secondaryHref: "/planes"
    },
    en: {
      title: "Puerto Rico Home Values | Closed Sales",
      description: "Estimate Puerto Rico home values using closed-sale comps, price per square foot, CRIM context, and market trends.",
      eyebrow: "HOME VALUE DATA",
      h1: "How much is my house worth in Puerto Rico?",
      intro: [
        "CASADATA helps estimate Puerto Rico property value using closed-sale comps, price per square foot, market trends, structure size, lot size, municipality, neighborhood, and real transaction data."
      ],
      sections: [
        {
          heading: "Why closed sales matter",
          body: ["Asking prices show what someone wants. Closed sales show what buyers and sellers actually accepted in completed transactions."]
        },
        {
          heading: "What CASADATA analyzes",
          items: ["Nearby recent sales.", "Similar properties by size, type, and location.", "Price per square foot.", "Likely value range.", "CRIM/cadastre context and estimated contribution.", "Flood, repossessed, and refinanced indicators."]
        }
      ],
      faqs: [
        { question: "Does CASADATA provide an official appraisal?", answer: "No. CASADATA helps estimate and support a range with comps, but official appraisals should be completed by licensed professionals." }
      ],
      primaryCta: "Estimate value with data",
      secondaryCta: "View plans",
      primaryHref: "/?go=prices&src=seo_home_values_en",
      secondaryHref: "/planes"
    }
  }),
  ...createTopicPair({
    slug: "repossessed",
    priority: 0.78,
    esPath: "/es/propiedades-reposeidas-puerto-rico",
    enPath: "/en/foreclosed-homes-puerto-rico",
    es: {
      title: "Propiedades reposeidas Puerto Rico",
      description: "Analiza propiedades reposeidas en Puerto Rico con ventas cerradas, comparables, mapas, riesgos y contexto de mercado.",
      eyebrow: "PROPIEDADES REPOSEIDAS",
      h1: "Propiedades bancarias y reposeidas en Puerto Rico",
      intro: [
        "Las propiedades reposeidas pueden representar oportunidades, pero tambien requieren analizar precio, condicion, liquidez y contexto antes de actuar.",
        "CASADATA ayuda a identificar marcadores de propiedades reposeidas y compararlas contra ventas cerradas."
      ],
      sections: [
        {
          heading: "Como evaluar una oportunidad",
          items: [
            "Compara precio contra ventas cerradas.",
            "Revisa demanda y liquidez en la zona.",
            "Considera riesgos de inundabilidad.",
            "Valida documentos y condiciones con profesionales correspondientes."
          ]
        },
        limitationSection
      ],
      faqs: coreFaqs.slice(0, 4),
      primaryCta: "Analizar reposeidas",
      secondaryCta: "Ver planes",
      primaryHref: "/?go=prices&src=seo_reposeidas",
      secondaryHref: "/planes"
    },
    en: {
      title: "Foreclosed Homes Puerto Rico | Comps",
      description: "Analyze foreclosed and repossessed homes in Puerto Rico with closed sales, comps, maps, risk indicators, and exports.",
      eyebrow: "FORECLOSED HOMES PUERTO RICO",
      h1: "Foreclosed and repossessed properties in Puerto Rico",
      intro: [
        "Repossessed properties can create opportunities, but they require careful analysis of price, condition, liquidity, and risk.",
        "CASADATA helps identify repossession markers and compare properties against closed sales."
      ],
      sections: [
        { heading: "How to evaluate an opportunity", items: ["Compare price against closed sales.", "Review area demand and liquidity.", "Consider flood-risk indicators.", "Validate documents and conditions with qualified professionals."] }
      ],
      faqs: [
        { question: "Are all foreclosed homes good deals?", answer: "No. Price, condition, restrictions, and market liquidity must be evaluated with real data and proper diligence." }
      ],
      primaryCta: "Analyze repossessed properties",
      secondaryCta: "View plans",
      primaryHref: "/?go=prices&src=seo_foreclosures_en",
      secondaryHref: "/planes"
    }
  }),
  ...createTopicPair({
    slug: "crim",
    priority: 0.82,
    esPath: "/es/estimador-crim-puerto-rico",
    enPath: "/en/crim-property-tax-pr",
    es: {
      title: "Estimador CRIM Puerto Rico",
      description: "Entiende contribuciones CRIM con contexto de catastro, valor tributable y estimado mensual cuando el dato esta disponible.",
      eyebrow: "CRIM PUERTO RICO",
      h1: "Estimador de contribuciones CRIM en Puerto Rico",
      intro: [
        "Las contribuciones de propiedad en Puerto Rico pueden afectar precio, rendimiento y decision de compra.",
        "CASADATA incluye contexto de CRIM/catastro y estimados mensuales cuando los datos estan disponibles."
      ],
      sections: [
        {
          heading: "Por que CRIM importa",
          body: [
            "El pago contributivo puede cambiar la rentabilidad de una inversion, el costo de retener una propiedad y la expectativa de un comprador."
          ]
        },
        limitationSection
      ],
      faqs: coreFaqs,
      primaryCta: "Estimar CRIM con CASADATA",
      secondaryCta: "Ver planes",
      primaryHref: "/?go=prices&src=seo_crim",
      secondaryHref: "/planes"
    },
    en: {
      title: "CRIM Property Tax PR | Estimates",
      description: "Understand Puerto Rico CRIM property tax estimates using taxable values, municipal context, and market data.",
      eyebrow: "CRIM PROPERTY TAX PR",
      h1: "Puerto Rico CRIM property tax estimates",
      intro: [
        "Property taxes in Puerto Rico can affect pricing, investment yield, and purchase decisions.",
        "CASADATA includes CRIM/cadastre context and monthly estimates when data is available."
      ],
      sections: [
        { heading: "Why CRIM matters", body: ["Property tax cost can change investment returns, ownership cost, and buyer expectations."] },
        limitationSection
      ],
      faqs: [
        { question: "Is the CRIM estimate official?", answer: "No. It is preliminary guidance. Official figures should be confirmed with CRIM or authorized sources." }
      ],
      primaryCta: "Estimate CRIM with CASADATA",
      secondaryCta: "View plans",
      primaryHref: "/?go=prices&src=seo_crim_en",
      secondaryHref: "/planes"
    }
  })
];

const searchIntentPages = [
  makeSpanishPage({
    slug: "precio-vendido-casa-puerto-rico",
    path: "/es/precio-vendido-casa-puerto-rico",
    priority: 0.88,
    alternates: {
      "es-PR": "/es/precio-vendido-casa-puerto-rico",
      "en-US": "/en/puerto-rico-sold-home-prices",
      "x-default": "/es/precio-vendido-casa-puerto-rico"
    },
    title: "Precio vendido de casa Puerto Rico | Ventas reales",
    description: "Busca precios vendidos de casas en Puerto Rico con ventas cerradas, comparables, fecha de venta, precio por pie cuadrado y contexto CRIM.",
    eyebrow: "PRECIO VENDIDO DE CASA",
    h1: "Precio vendido de una casa en Puerto Rico",
    intro: [
      "Para estimar valor no basta con mirar el precio pedido. El precio vendido muestra lo que comprador y vendedor realmente aceptaron.",
      "CASADATA ayuda a revisar ventas cerradas cercanas, comparar propiedades similares y validar rangos de valor con evidencia local."
    ],
    sections: [
      {
        heading: "Que puedes validar",
        items: [
          "Precio de venta y fecha de transaccion.",
          "Comparables cercanos por municipio, zona, tipo y tamano.",
          "Precio por pie cuadrado y rango probable de valor.",
          "CRIM/catastro, documentos disponibles y alertas de riesgo cuando existan."
        ]
      },
      {
        heading: "Cuando usar esta busqueda",
        body: [
          "Usala antes de hacer una oferta, vender una propiedad, preparar una opinion de precio o confirmar si un listado esta alineado con ventas reales."
        ]
      },
      limitationSection
    ],
    faqs: coreFaqs,
    primaryCta: "Ver precios vendidos",
    primaryHref: "/?go=prices&src=seo_precio_vendido"
  }),
  makeSpanishPage({
    slug: "valor-propiedad-puerto-rico",
    path: "/es/valor-propiedad-puerto-rico",
    priority: 0.88,
    alternates: {
      "es-PR": "/es/valor-propiedad-puerto-rico",
      "en-US": "/en/puerto-rico-property-values",
      "x-default": "/es/valor-propiedad-puerto-rico"
    },
    title: "Valor de propiedad Puerto Rico | CASADATA",
    description: "Analiza el valor de una propiedad en Puerto Rico con ventas cerradas, comparables, CRIM, mapas, riesgos y exportaciones.",
    eyebrow: "VALOR DE PROPIEDAD",
    h1: "Valor de propiedad en Puerto Rico con datos de ventas reales",
    intro: [
      "CASADATA organiza ventas cerradas y comparables para ayudar a compradores, vendedores, corredores, tasadores e inversionistas a estimar valor con mejor contexto.",
      "El analisis puede incluir precio por pie cuadrado, tamano, zona, fecha, CRIM/catastro y senales de riesgo."
    ],
    sections: [
      {
        heading: "Senales utiles para valor",
        items: [
          "Ventas recientes y comparables historicos.",
          "Rangos de precio por tamano y localizacion.",
          "Tendencias, liquidez y propiedades atipicas.",
          "Estimados de valor y equidad cuando la data lo permite."
        ]
      },
      {
        heading: "Valor para decisiones reales",
        body: [
          "La meta no es adivinar un numero aislado; es construir un rango defendible usando evidencia de mercado disponible."
        ]
      },
      limitationSection
    ],
    faqs: coreFaqs,
    primaryCta: "Analizar valor",
    primaryHref: "/?go=prices&src=seo_valor_propiedad"
  }),
  makeSpanishPage({
    slug: "casas-reposeidas-puerto-rico",
    path: "/es/casas-reposeidas-puerto-rico",
    priority: 0.82,
    alternates: {
      "es-PR": "/es/casas-reposeidas-puerto-rico",
      "en-US": "/en/puerto-rico-repossessed-properties",
      "x-default": "/es/casas-reposeidas-puerto-rico"
    },
    title: "Casas reposeidas Puerto Rico | Comparables y ventas",
    description: "Evalua casas reposeidas en Puerto Rico con comparables, ventas cerradas, mapas, riesgos, CRIM y contexto de mercado.",
    eyebrow: "CASAS REPOSEIDAS",
    h1: "Casas reposeidas en Puerto Rico: compara antes de comprar",
    intro: [
      "Una casa reposeida puede parecer oportunidad, pero el valor depende de precio, zona, liquidez, condicion y riesgo.",
      "CASADATA ayuda a comparar propiedades con marcadores de reposeida contra ventas cerradas cercanas."
    ],
    sections: [
      {
        heading: "Analisis antes de ofertar",
        items: [
          "Comparar contra ventas cerradas similares.",
          "Revisar actividad reciente en la zona.",
          "Identificar alertas de inundabilidad y contexto CRIM.",
          "Exportar datos para estudiar la oportunidad con mas detalle."
        ]
      },
      limitationSection
    ],
    faqs: coreFaqs.slice(0, 4),
    primaryCta: "Buscar casas reposeidas",
    primaryHref: "/?go=prices&src=seo_casas_reposeidas"
  }),
  makeSpanishPage({
    slug: "reposeidas-bancos-puerto-rico",
    path: "/es/reposeidas-bancos-puerto-rico",
    priority: 0.8,
    title: "Reposeidas de bancos Puerto Rico | Datos y comparables",
    description: "Analiza propiedades reposeidas por bancos en Puerto Rico con ventas cerradas, comparables, CRIM, mapas y senales de riesgo.",
    eyebrow: "REPOSEIDAS DE BANCOS",
    h1: "Reposeidas de bancos en Puerto Rico",
    intro: [
      "Quien busca reposeidas de bancos necesita separar oportunidad de riesgo. CASADATA ayuda a revisar precios vendidos, comparables y contexto local antes de invertir tiempo.",
      "La plataforma no sustituye la validacion directa con el banco, agente, registro o profesional correspondiente."
    ],
    sections: [
      {
        heading: "Que revisar en una reposeida bancaria",
        items: [
          "Precio frente a ventas cerradas comparables.",
          "Historial y liquidez del area.",
          "Datos CRIM/catastro y documentos disponibles cuando existan.",
          "Indicadores de inundabilidad, refinanciacion y otros riesgos."
        ]
      },
      limitationSection
    ],
    faqs: coreFaqs.slice(0, 4),
    primaryCta: "Analizar reposeidas",
    primaryHref: "/?go=prices&src=seo_reposeidas_bancos"
  }),
  makeSpanishPage({
    slug: "cuanto-se-paga-crim-casa-puerto-rico",
    path: "/es/cuanto-se-paga-crim-casa-puerto-rico",
    priority: 0.8,
    alternates: {
      "es-PR": "/es/cuanto-se-paga-crim-casa-puerto-rico",
      "en-US": "/en/puerto-rico-crim-property-tax",
      "x-default": "/es/cuanto-se-paga-crim-casa-puerto-rico"
    },
    title: "Cuanto se paga de CRIM por una casa en Puerto Rico",
    description: "Entiende el costo CRIM de una casa en Puerto Rico con contexto catastral, valor tributable y estimados mensuales cuando existen.",
    eyebrow: "CRIM DE UNA CASA",
    h1: "Cuanto se paga de CRIM por una casa en Puerto Rico",
    intro: [
      "El CRIM puede cambiar el costo real de comprar, retener o invertir en una propiedad.",
      "CASADATA muestra contexto CRIM/catastro y estimados mensuales cuando los datos estan disponibles para ayudar a anticipar el impacto."
    ],
    sections: [
      {
        heading: "Por que revisar CRIM temprano",
        items: [
          "Ayuda a estimar costo mensual de retencion.",
          "Puede afectar rendimiento de inversion.",
          "Ayuda a comparar propiedades con precios parecidos pero cargas distintas.",
          "Da contexto adicional antes de hacer una oferta."
        ]
      },
      limitationSection
    ],
    faqs: coreFaqs,
    primaryCta: "Revisar CRIM",
    primaryHref: "/?go=prices&src=seo_crim_casa"
  }),
  makeSpanishPage({
    slug: "comparables-para-tasadores-puerto-rico",
    path: "/es/comparables-para-tasadores-puerto-rico",
    priority: 0.82,
    alternates: {
      "es-PR": "/es/comparables-para-tasadores-puerto-rico",
      "en-US": "/en/puerto-rico-appraisal-comps",
      "x-default": "/es/comparables-para-tasadores-puerto-rico"
    },
    title: "Comparables para tasadores Puerto Rico | CASADATA",
    description: "Comparables para tasadores en Puerto Rico con ventas cerradas, filtros, mapas, CRIM, documentos disponibles y exportacion CSV.",
    eyebrow: "COMPARABLES PARA TASADORES",
    h1: "Comparables para tasadores en Puerto Rico",
    intro: [
      "CASADATA ayuda a organizar evidencia de mercado para seleccion, revision y archivo de comparables.",
      "El flujo esta pensado para reducir trabajo manual al revisar ventas cerradas, precio por pie cuadrado, CRIM/catastro, mapas y exportaciones."
    ],
    sections: [
      {
        heading: "Flujo profesional de comparables",
        items: [
          "Filtrar por municipio, zona, fecha, precio y tamano.",
          "Comparar residencial, multifamiliar, solares y comercial cuando aplique.",
          "Exportar CSV compatible con Excel.",
          "Revisar documentos disponibles, CRIM e indicadores de riesgo."
        ]
      },
      limitationSection
    ],
    faqs: coreFaqs,
    primaryCta: "Explorar comparables",
    primaryHref: "/?go=prices&src=seo_tasadores_comps"
  }),
  makeSpanishPage({
    slug: "reporte-comparables-puerto-rico",
    path: "/es/reporte-comparables-puerto-rico",
    priority: 0.78,
    title: "Reporte de comparables Puerto Rico | CASADATA",
    description: "Prepara reportes de comparables en Puerto Rico con ventas cerradas, mapas, precio por pie cuadrado, CRIM y exportacion.",
    eyebrow: "REPORTE DE COMPARABLES",
    h1: "Reporte de comparables en Puerto Rico",
    intro: [
      "Cuando necesitas demostrar un rango de valor, el reporte importa tanto como la busqueda.",
      "CASADATA organiza ventas cerradas, filtros, mapas y exportaciones para convertir datos dispersos en evidencia util."
    ],
    sections: [
      {
        heading: "Que debe incluir un reporte",
        items: [
          "Propiedades comparables seleccionadas.",
          "Precio vendido, fecha y precio por pie cuadrado.",
          "Mapa o area de busqueda.",
          "Contexto CRIM/catastro, documentos disponibles y riesgos cuando existan."
        ]
      },
      limitationSection
    ],
    faqs: coreFaqs.slice(0, 5),
    primaryCta: "Crear evidencia con CASADATA",
    primaryHref: "/?go=prices&src=seo_reporte_comparables"
  }),
  makeSpanishPage({
    slug: "datos-ventas-bienes-raices-puerto-rico",
    path: "/es/datos-ventas-bienes-raices-puerto-rico",
    priority: 0.78,
    alternates: {
      "es-PR": "/es/datos-ventas-bienes-raices-puerto-rico",
      "en-US": "/en/puerto-rico-real-estate-sales-data",
      "x-default": "/es/datos-ventas-bienes-raices-puerto-rico"
    },
    title: "Datos de ventas de bienes raices Puerto Rico",
    description: "Consulta datos de ventas de bienes raices en Puerto Rico con transacciones historicas, comparables, mapas y exportaciones.",
    eyebrow: "DATOS DE VENTAS",
    h1: "Datos de ventas de bienes raices en Puerto Rico",
    intro: [
      "Los datos de ventas ayudan a entender precios reales, actividad por municipio y comportamiento de diferentes tipos de propiedad.",
      "CASADATA organiza transacciones historicas para analisis de compra, venta, tasacion, corretaje e inversion."
    ],
    sections: [
      {
        heading: "Analisis que puedes hacer",
        items: [
          "Filtrar ventas por fecha, municipio, precio y tamano.",
          "Comparar mercados con alta o baja liquidez.",
          "Detectar ventas atipicas y rangos de precio.",
          "Exportar datos para analisis profesional."
        ]
      },
      limitationSection
    ],
    faqs: coreFaqs,
    primaryCta: "Explorar datos de ventas",
    primaryHref: "/?go=prices&src=seo_datos_ventas"
  }),
  makeSpanishPage({
    slug: "historial-ventas-propiedades-puerto-rico",
    path: "/es/historial-ventas-propiedades-puerto-rico",
    priority: 0.76,
    title: "Historial de ventas de propiedades Puerto Rico",
    description: "Investiga historial de ventas de propiedades en Puerto Rico con transacciones cerradas, comparables, documentos disponibles y contexto de mercado.",
    eyebrow: "HISTORIAL DE VENTAS",
    h1: "Historial de ventas de propiedades en Puerto Rico",
    intro: [
      "El historial de ventas puede revelar cambios de precio, actividad del area y contexto que no aparece en un listado activo.",
      "CASADATA ayuda a revisar transacciones cerradas y comparar propiedades a traves del tiempo."
    ],
    sections: [
      {
        heading: "Por que mirar el historial",
        items: [
          "Entender precios previos y fechas de venta.",
          "Comparar comportamiento de zonas y municipios.",
          "Revisar contexto documental disponible.",
          "Separar evidencia reciente de ventas antiguas."
        ]
      },
      limitationSection
    ],
    faqs: coreFaqs.slice(0, 5),
    primaryCta: "Ver historial con datos",
    primaryHref: "/?go=prices&src=seo_historial_ventas"
  }),
  makeSpanishPage({
    slug: "comparables-multifamiliar-puerto-rico",
    path: "/es/comparables-multifamiliar-puerto-rico",
    priority: 0.76,
    alternates: {
      "es-PR": "/es/comparables-multifamiliar-puerto-rico",
      "en-US": "/en/puerto-rico-multifamily-sales-data",
      "x-default": "/es/comparables-multifamiliar-puerto-rico"
    },
    title: "Comparables multifamiliar Puerto Rico | Ventas cerradas",
    description: "Analiza comparables multifamiliares en Puerto Rico con ventas cerradas, mapas, precio por pie cuadrado, CRIM y exportaciones.",
    eyebrow: "COMPARABLES MULTIFAMILIAR",
    h1: "Comparables multifamiliares en Puerto Rico",
    intro: [
      "Las propiedades multifamiliares requieren comparar mas que precio total: zona, tamano, actividad reciente, liquidez y uso del activo importan.",
      "CASADATA ayuda a revisar ventas cerradas y contexto local para analisis de inversion o tasacion."
    ],
    sections: [
      {
        heading: "Variables utiles",
        items: [
          "Ventas multifamiliares cercanas cuando estan disponibles.",
          "Precio por pie cuadrado, tamano y fecha de venta.",
          "Contexto CRIM/catastro y documentos disponibles.",
          "Exportacion para analisis de rendimiento o underwriting."
        ]
      },
      limitationSection
    ],
    faqs: coreFaqs.slice(0, 5),
    primaryCta: "Analizar multifamiliares",
    primaryHref: "/?go=prices&src=seo_multifamiliar"
  }),
  makeSpanishPage({
    slug: "comparables-de-terrenos-puerto-rico",
    path: "/es/comparables-de-terrenos-puerto-rico",
    priority: 0.74,
    alternates: {
      "es-PR": "/es/comparables-de-terrenos-puerto-rico",
      "en-US": "/en/puerto-rico-land-comps",
      "x-default": "/es/comparables-de-terrenos-puerto-rico"
    },
    title: "Comparables de terrenos Puerto Rico | CASADATA",
    description: "Compara terrenos y solares en Puerto Rico con ventas cerradas, tamano de solar, mapas, CRIM y contexto de mercado.",
    eyebrow: "COMPARABLES DE TERRENOS",
    h1: "Comparables de terrenos en Puerto Rico",
    intro: [
      "Los terrenos se comparan distinto a casas: cabida, localizacion, acceso, mercado cercano y uso potencial pesan mucho.",
      "CASADATA ayuda a revisar ventas cerradas de terrenos y solares cuando la data esta disponible."
    ],
    sections: [
      {
        heading: "Datos para comparar terrenos",
        items: [
          "Ventas cerradas de solares y terrenos.",
          "Tamano de terreno y precio relativo.",
          "Mapa, municipio y zona.",
          "Contexto CRIM/catastro y documentos disponibles cuando existan."
        ]
      },
      limitationSection
    ],
    faqs: coreFaqs.slice(0, 5),
    primaryCta: "Buscar comparables de terrenos",
    primaryHref: "/?go=prices&src=seo_terrenos"
  }),
  makeSpanishPage({
    slug: "ventas-de-solares-puerto-rico",
    path: "/es/ventas-de-solares-puerto-rico",
    priority: 0.72,
    title: "Ventas de solares Puerto Rico | Datos y comparables",
    description: "Explora ventas de solares en Puerto Rico con comparables, mapas, tamano de terreno, precio y contexto de mercado.",
    eyebrow: "VENTAS DE SOLARES",
    h1: "Ventas de solares en Puerto Rico",
    intro: [
      "Constructores, desarrolladores, inversionistas y tasadores necesitan evidencia de ventas reales para evaluar solares.",
      "CASADATA organiza transacciones, mapas y filtros para estudiar precio, ubicacion y actividad de mercado."
    ],
    sections: [
      {
        heading: "Usos comunes",
        items: [
          "Evaluar compra de solar para construir.",
          "Comparar precio por area y municipio.",
          "Revisar ventas cercanas antes de ofertar.",
          "Exportar evidencia para analisis profesional."
        ]
      },
      limitationSection
    ],
    faqs: coreFaqs.slice(0, 4),
    primaryCta: "Analizar solares",
    primaryHref: "/?go=prices&src=seo_solares"
  }),
  makeEnglishPage({
    slug: "puerto-rico-sold-home-prices",
    path: "/en/puerto-rico-sold-home-prices",
    priority: 0.86,
    alternates: {
      "es-PR": "/es/precio-vendido-casa-puerto-rico",
      "en-US": "/en/puerto-rico-sold-home-prices",
      "x-default": "/es/precio-vendido-casa-puerto-rico"
    },
    title: "Puerto Rico Sold Home Prices | Closed Sales",
    description: "Find Puerto Rico sold home prices with closed-sale comps, sale dates, price per square foot, CRIM context, and market filters.",
    eyebrow: "SOLD HOME PRICES",
    h1: "Puerto Rico sold home prices from closed sales",
    intro: [
      "Asking prices do not prove market value. Sold prices show what buyers and sellers actually accepted.",
      "CASADATA helps mainland buyers, diaspora buyers, agents, appraisers, and investors compare Puerto Rico closed sales with local context."
    ],
    sections: [
      {
        heading: "What you can validate",
        items: [
          "Sold price and sale date.",
          "Comparable properties by area, size, property type, and period.",
          "Price per square foot and value range.",
          "CRIM/cadastre context, available documents, and risk indicators when available."
        ]
      },
      limitationSection
    ],
    faqs: [
      { question: "Are these asking prices?", answer: "No. CASADATA focuses on closed-sale evidence and related market context." },
      { question: "Does this replace an appraisal?", answer: "No. It helps organize market evidence; formal appraisals should be completed by licensed professionals." }
    ],
    primaryCta: "Find sold prices",
    primaryHref: "/?go=prices&src=seo_sold_home_prices"
  }),
  makeEnglishPage({
    slug: "puerto-rico-property-values",
    path: "/en/puerto-rico-property-values",
    priority: 0.86,
    alternates: {
      "es-PR": "/es/valor-propiedad-puerto-rico",
      "en-US": "/en/puerto-rico-property-values",
      "x-default": "/es/valor-propiedad-puerto-rico"
    },
    title: "Puerto Rico Property Values | CASADATA",
    description: "Estimate Puerto Rico property values using closed sales, comps, CRIM context, maps, trends, risk indicators, and exports.",
    eyebrow: "PROPERTY VALUES",
    h1: "Puerto Rico property values with closed-sale data",
    intro: [
      "Property value in Puerto Rico depends on more than a listing price. Location, size, sale date, property type, CRIM context, and comparable sales matter.",
      "CASADATA helps users build a more defensible value range from actual market evidence."
    ],
    sections: [
      {
        heading: "Useful value signals",
        items: [
          "Recent and historical closed sales.",
          "Similar properties by area, size, and type.",
          "Price per square foot, value ranges, trends, and liquidity.",
          "Flood, repossessed, refinanced, CRIM, and document context when available."
        ]
      },
      limitationSection
    ],
    primaryCta: "Analyze property value",
    primaryHref: "/?go=prices&src=seo_property_values"
  }),
  makeEnglishPage({
    slug: "puerto-rico-repossessed-properties",
    path: "/en/puerto-rico-repossessed-properties",
    priority: 0.8,
    alternates: {
      "es-PR": "/es/casas-reposeidas-puerto-rico",
      "en-US": "/en/puerto-rico-repossessed-properties",
      "x-default": "/es/casas-reposeidas-puerto-rico"
    },
    title: "Puerto Rico Repossessed Properties | Comps",
    description: "Analyze Puerto Rico repossessed properties with closed sales, comparable data, maps, CRIM context, and risk indicators.",
    eyebrow: "REPOSSESSED PROPERTIES",
    h1: "Puerto Rico repossessed properties with market context",
    intro: [
      "Repossessed properties can be opportunities, but only if price, liquidity, risk, and local comps support the deal.",
      "CASADATA helps compare repossession markers against closed-sale evidence."
    ],
    sections: [
      {
        heading: "Before pursuing a repo property",
        items: [
          "Compare the property against nearby closed sales.",
          "Review area demand and market liquidity.",
          "Check flood, CRIM, document, and refinance context when available.",
          "Export data for professional review."
        ]
      },
      limitationSection
    ],
    primaryCta: "Analyze repossessed properties",
    primaryHref: "/?go=prices&src=seo_repossessed_properties"
  }),
  makeEnglishPage({
    slug: "puerto-rico-crim-property-tax",
    path: "/en/puerto-rico-crim-property-tax",
    priority: 0.8,
    alternates: {
      "es-PR": "/es/cuanto-se-paga-crim-casa-puerto-rico",
      "en-US": "/en/puerto-rico-crim-property-tax",
      "x-default": "/es/cuanto-se-paga-crim-casa-puerto-rico"
    },
    title: "Puerto Rico CRIM Property Tax | Buyer Guide",
    description: "Understand Puerto Rico CRIM property tax context, taxable value, monthly estimates, and buyer/investor cost impact.",
    eyebrow: "CRIM PROPERTY TAX",
    h1: "Puerto Rico CRIM property tax context for buyers and investors",
    intro: [
      "CRIM property tax can affect affordability, holding cost, and investment returns in Puerto Rico.",
      "CASADATA includes CRIM/cadastre context and monthly estimates when data is available."
    ],
    sections: [
      {
        heading: "Why CRIM matters",
        items: [
          "Estimate ownership cost before buying.",
          "Compare properties with similar prices but different tax context.",
          "Review market value together with carrying cost.",
          "Confirm official figures with CRIM or qualified professionals."
        ]
      },
      limitationSection
    ],
    primaryCta: "Review CRIM context",
    primaryHref: "/?go=prices&src=seo_crim_property_tax"
  }),
  makeEnglishPage({
    slug: "puerto-rico-appraisal-comps",
    path: "/en/puerto-rico-appraisal-comps",
    priority: 0.8,
    alternates: {
      "es-PR": "/es/comparables-para-tasadores-puerto-rico",
      "en-US": "/en/puerto-rico-appraisal-comps",
      "x-default": "/es/comparables-para-tasadores-puerto-rico"
    },
    title: "Puerto Rico Appraisal Comps | CASADATA",
    description: "Review Puerto Rico appraisal comps with closed sales, map filters, CRIM context, available documents, and CSV exports.",
    eyebrow: "APPRAISAL COMPS",
    h1: "Puerto Rico appraisal comps for professional review",
    intro: [
      "CASADATA helps appraisers and valuation professionals organize closed-sale evidence for Puerto Rico properties.",
      "Use filters, maps, exports, CRIM context, and available document signals to support comparable selection."
    ],
    sections: [
      {
        heading: "Professional comp workflow",
        items: [
          "Closed sales by municipality, area, date, price, and size.",
          "Residential, multifamily, land, and commercial comparables when available.",
          "CSV export for spreadsheet analysis.",
          "CRIM, document, flood, repossessed, and refinance context."
        ]
      },
      limitationSection
    ],
    primaryCta: "Explore appraisal comps",
    primaryHref: "/?go=prices&src=seo_appraisal_comps"
  }),
  makeEnglishPage({
    slug: "puerto-rico-multifamily-sales-data",
    path: "/en/puerto-rico-multifamily-sales-data",
    priority: 0.76,
    alternates: {
      "es-PR": "/es/comparables-multifamiliar-puerto-rico",
      "en-US": "/en/puerto-rico-multifamily-sales-data",
      "x-default": "/es/comparables-multifamiliar-puerto-rico"
    },
    title: "Puerto Rico Multifamily Sales Data | CASADATA",
    description: "Analyze Puerto Rico multifamily sales data with closed sales, comps, maps, CRIM context, and exports for underwriting.",
    eyebrow: "MULTIFAMILY SALES DATA",
    h1: "Puerto Rico multifamily sales data for investors and appraisers",
    intro: [
      "Multifamily analysis requires more than a single asking price. Closed sales, area liquidity, size, and local risk context matter.",
      "CASADATA helps investors and appraisers compare multifamily evidence in Puerto Rico."
    ],
    sections: [
      {
        heading: "What to compare",
        items: [
          "Nearby multifamily closed sales when available.",
          "Sale date, price, structure size, and land size.",
          "Market activity by area and period.",
          "CSV exports for underwriting and professional review."
        ]
      },
      limitationSection
    ],
    primaryCta: "Analyze multifamily data",
    primaryHref: "/?go=prices&src=seo_multifamily_sales"
  }),
  makeEnglishPage({
    slug: "puerto-rico-land-comps",
    path: "/en/puerto-rico-land-comps",
    priority: 0.74,
    alternates: {
      "es-PR": "/es/comparables-de-terrenos-puerto-rico",
      "en-US": "/en/puerto-rico-land-comps",
      "x-default": "/es/comparables-de-terrenos-puerto-rico"
    },
    title: "Puerto Rico Land Comps | Lots and Land Sales",
    description: "Compare Puerto Rico land comps and lot sales with closed transactions, maps, land size, CRIM context, and exports.",
    eyebrow: "LAND COMPS",
    h1: "Puerto Rico land comps and lot sales",
    intro: [
      "Land and lots require a different comp workflow than houses: size, location, access, zoning context, and nearby sales all matter.",
      "CASADATA helps organize closed-sale land evidence when available."
    ],
    sections: [
      {
        heading: "Land data signals",
        items: [
          "Closed land and lot sales.",
          "Land size, municipality, and map context.",
          "CRIM/cadastre and available document context.",
          "Exports for builders, developers, appraisers, and investors."
        ]
      },
      limitationSection
    ],
    primaryCta: "Find land comps",
    primaryHref: "/?go=prices&src=seo_land_comps"
  }),
  makeEnglishPage({
    slug: "puerto-rico-property-records",
    path: "/en/puerto-rico-property-records",
    priority: 0.72,
    title: "Puerto Rico Property Records | Market Research",
    description: "Research Puerto Rico property records context with closed sales, CRIM/cadastre data, available document links, and market comps.",
    eyebrow: "PROPERTY RECORDS",
    h1: "Puerto Rico property records for market research",
    intro: [
      "CASADATA helps users research property-related market context such as closed sales, CRIM/cadastre signals, available document links, and comparable transactions.",
      "It is a market research tool, not an official title, registry, or legal-certainty source."
    ],
    sections: [
      {
        heading: "What CASADATA can support",
        items: [
          "Closed-sale history and comparable transactions.",
          "CRIM/cadastre context when available.",
          "Available deed, receipt, or document references when the data provides them.",
          "Map and export workflows for further diligence."
        ]
      },
      limitationSection
    ],
    primaryCta: "Research property data",
    primaryHref: "/?go=prices&src=seo_property_records"
  }),
  makeEnglishPage({
    slug: "puerto-rico-real-estate-investor-data",
    path: "/en/puerto-rico-real-estate-investor-data",
    priority: 0.72,
    title: "Puerto Rico Real Estate Investor Data | CASADATA",
    description: "Use Puerto Rico real estate investor data for closed sales, repossessed markers, CRIM context, maps, comps, and exports.",
    eyebrow: "INVESTOR DATA",
    h1: "Puerto Rico real estate investor data",
    intro: [
      "Investors need to validate price, risk, liquidity, and comparable sales before committing time or capital.",
      "CASADATA helps organize Puerto Rico sales data, repo/refinance markers, CRIM context, flood signals, and exports."
    ],
    sections: [
      {
        heading: "Investor workflows",
        items: [
          "Compare acquisition price against closed sales.",
          "Review area activity and liquidity.",
          "Identify repossessed, refinanced, and flood-risk signals.",
          "Export data for underwriting and follow-up."
        ]
      },
      limitationSection
    ],
    primaryCta: "Analyze investor data",
    primaryHref: "/?go=prices&src=seo_investor_data"
  }),
  makeEnglishPage({
    slug: "puerto-rico-buyer-seller-data",
    path: "/en/puerto-rico-buyer-seller-data",
    priority: 0.7,
    title: "Puerto Rico Buyer and Seller Data | CASADATA PlusMAX",
    description: "Explore Puerto Rico buyer and seller data context in CASADATA PlusMAX with closed sales, comps, maps, and exports.",
    eyebrow: "BUYER AND SELLER DATA",
    h1: "Puerto Rico buyer and seller data for real estate research",
    intro: [
      "Some Puerto Rico transaction workflows require more context than price alone.",
      "CASADATA PlusMAX can expose buyer and seller data where available, alongside closed sales, maps, CRIM context, and exports."
    ],
    sections: [
      {
        heading: "Why this data helps",
        items: [
          "Research market participants in closed transactions.",
          "Understand transaction context beyond the sale price.",
          "Support professional analysis for brokers, investors, and appraisers.",
          "Export data for organized follow-up."
        ]
      },
      limitationSection
    ],
    primaryCta: "View PlusMAX access",
    primaryHref: "/?go=prices&src=seo_buyer_seller_data"
  })
];

const methodologyPage = makeSpanishPage({
  slug: "metodologia-datos",
  path: "/es/metodologia-datos-puerto-rico",
  priority: 0.82,
  title: "Metodologia de datos CASADATA Puerto Rico",
  description: "Conoce como CASADATA organiza ventas cerradas, CRIM, documentos disponibles y senales de riesgo para analizar propiedades.",
  eyebrow: "METODOLOGIA DE DATOS",
  h1: "Como CASADATA construye sus comparables de Puerto Rico",
  intro: [
    "CASADATA organiza datos de ventas cerradas, informacion de CRIM/catastro, documentos disponibles y senales de riesgo para ayudar a usuarios a analizar valor y mercado en Puerto Rico."
  ],
  sections: [
    {
      heading: "Que datos usamos",
      items: [
        "Ventas cerradas de propiedades en Puerto Rico.",
        "Datos de comprador y vendedor cuando el nivel de acceso lo permite.",
        "Municipio, zona, direccion y coordenadas cuando estan disponibles.",
        "Tamano de estructura y tamano de solar cuando estan disponibles.",
        "CRIM/catastro y estimados de contribucion.",
        "Referencias o enlaces de escritura, recibos y documentos disponibles.",
        "Marcadores de reposeidas, refinanciadas e inundabilidad."
      ]
    },
    limitationSection
  ],
  faqs: coreFaqs
});

const comparisonPage = makeSpanishPage({
  slug: "comparacion-herramientas",
  path: "/es/casadata-vs-comparables-puerto-rico",
  priority: 0.78,
  title: "Comparables Puerto Rico | Que comparar",
  description: "Evalua que debe tener una herramienta de comparables: ventas cerradas, CRIM, documentos, riesgos, exportacion y mapas.",
  eyebrow: "COMPARACION DE HERRAMIENTAS",
  h1: "Comparables de Puerto Rico: que debe tener una buena herramienta",
  intro: [
    "Al comparar plataformas de comparables en Puerto Rico, evalua si ofrecen ventas cerradas, filtros por localizacion, datos de comprador/vendedor, CRIM/catastro, documentos disponibles, alertas de inundacion, exportacion y mapas."
  ],
  sections: [
    {
      heading: "Funciones a comparar",
      table: {
        headers: ["Funcion", "CASADATA", "Herramientas basicas de comparables", "Portales de listados"],
        rows: [
          ["Ventas cerradas de Puerto Rico", "Si", "Varia", "Limitado a ventas reportadas/listadas"],
          ["Datos de comprador/vendedor", "Si en PlusMAX", "Varia", "No siempre"],
          ["CRIM/catastro", "Si, cuando disponible", "Varia", "No enfocado en eso"],
          ["Escrituras o documentos disponibles", "Si, cuando existen", "Varia", "No siempre"],
          ["Alertas de inundacion", "Si", "Varia", "No siempre"],
          ["Exportacion a Excel/CSV", "Si", "Varia", "No siempre"]
        ]
      }
    },
    limitationSection
  ],
  faqs: coreFaqs.slice(0, 5)
});

const reportPages = [
  ["ejemplo-reporte-propiedad", "Ejemplo de reporte de propiedad en CASADATA", "propiedad"],
  ["ejemplo-reporte-comprador", "Ejemplo de reporte para comprador en CASADATA", "comprador"],
  ["ejemplo-reporte-cma-corredor", "Ejemplo de CMA para corredor en CASADATA", "corredor"],
  ["ejemplo-reporte-inversionista", "Ejemplo de analisis para inversionista en CASADATA", "inversionista"],
  ["ejemplo-paquete-tasador", "Ejemplo de paquete de datos para tasador", "tasador"]
].map(([slug, h1, audience]) => makeSpanishPage({
  slug,
  path: `/es/${slug}`,
  priority: 0.72,
  title: `${h1} | Puerto Rico`,
  description: `Ejemplo crawlable de como CASADATA organiza ventas cerradas, comparables, CRIM, documentos disponibles y riesgos para ${audience}.`,
  eyebrow: "EJEMPLO DE ANALISIS",
  h1,
  intro: [
    "Este ejemplo muestra como CASADATA organiza ventas cerradas, comparables, datos CRIM, documentos disponibles, mapa, estimado de valor y alertas de riesgo para apoyar decisiones de compra, venta, inversion o analisis profesional."
  ],
  sections: [
    {
      heading: "Secciones del analisis",
      items: [
        "Resumen de la propiedad.",
        "Estimado de valor y rango de mercado.",
        "Comparables seleccionados.",
        "Mapa de ventas cercanas.",
        "Precio por pie cuadrado.",
        "CRIM/catastro y contribucion estimada.",
        "Escrituras, recibos o documentos disponibles.",
        "Alertas de inundacion, reposeidas y refinanciadas."
      ]
    },
    limitationSection
  ],
  faqs: coreFaqs.slice(0, 4)
}));

const educationPages = [
  {
    slug: "como-buscar-comparables-puerto-rico",
    title: "Como buscar comparables en Puerto Rico",
    h1: "Como buscar comparables en Puerto Rico",
    description: "Aprende a buscar comparables con ventas cerradas, filtros de zona, precio, fecha, tamano, mapas y exportaciones."
  },
  {
    slug: "ventas-cerradas-vs-listados-activos",
    title: "Ventas cerradas vs listados activos",
    h1: "Ventas cerradas vs listados activos en Puerto Rico",
    description: "Conoce por que las ventas cerradas ayudan a entender mejor el valor real que los precios pedidos en listados activos."
  },
  {
    slug: "como-saber-si-una-propiedad-esta-sobrevalorada",
    title: "Como saber si una propiedad esta sobrevalorada",
    h1: "Como saber si una propiedad esta sobrevalorada",
    description: "Usa ventas cerradas, precio por pie cuadrado, CRIM, riesgos y liquidez para evaluar si una propiedad esta sobrevalorada."
  },
  {
    slug: "como-estimar-valor-propiedad-puerto-rico",
    title: "Como estimar valor de propiedad Puerto Rico",
    h1: "Como estimar el valor de una propiedad en Puerto Rico",
    description: "Estima valor con comparables de ventas cerradas, tamano, ubicacion, precio por pie cuadrado y tendencias de mercado."
  },
  {
    slug: "que-es-crim-puerto-rico",
    title: "Que es CRIM en Puerto Rico",
    h1: "Que es CRIM en Puerto Rico y por que importa",
    description: "Entiende como CRIM/catastro y contribuciones pueden afectar compra, venta, inversion y analisis de propiedades."
  },
  {
    slug: "que-es-una-escritura-de-propiedad",
    title: "Que es una escritura de propiedad",
    h1: "Que es una escritura de propiedad en Puerto Rico",
    description: "Conoce como las escrituras y documentos disponibles pueden aportar contexto al analizar una propiedad."
  },
  {
    slug: "zonas-inundables-propiedades-puerto-rico",
    title: "Zonas inundables y propiedades Puerto Rico",
    h1: "Zonas inundables en propiedades de Puerto Rico",
    description: "Aprende por que las alertas de inundabilidad son importantes al comparar propiedades y evaluar riesgo de ubicacion."
  },
  {
    slug: "cma-corredores-puerto-rico",
    title: "CMA para corredores en Puerto Rico",
    h1: "CMA para corredores en Puerto Rico con ventas cerradas",
    description: "Prepara opiniones de precio y conversaciones de captacion con comparables, mapas, CRIM y exportaciones."
  }
].map((page) => makeSpanishPage({
  ...page,
  path: `/es/${page.slug}`,
  priority: 0.7,
  eyebrow: "GUIA CASADATA",
  intro: [
    "CASADATA ayuda a convertir datos de ventas cerradas, mapas, filtros y contexto local en evidencia util para decisiones inmobiliarias en Puerto Rico."
  ],
  sections: [
    {
      heading: "Como CASADATA ayuda",
      items: [
        "Parte de ventas cerradas en vez de depender solo de precios pedidos.",
        "Permite filtrar por localizacion, precio, fecha y tamano.",
        "Muestra contexto de CRIM/catastro, documentos disponibles y senales de riesgo cuando existen.",
        "Ayuda a exportar datos para analisis profesional."
      ]
    },
    {
      heading: "Siguiente paso",
      body: [
        "Usa CASADATA para validar el mercado, comparar propiedades similares y documentar mejor tus decisiones."
      ],
      links: [{ href: "/planes", label: "Ver planes de CASADATA" }]
    },
    limitationSection
  ],
  faqs: coreFaqs.slice(0, 4)
}));

const municipalities = [
  ["Adjuntas", "adjuntas"], ["Aguada", "aguada"], ["Aguadilla", "aguadilla"], ["Aguas Buenas", "aguas-buenas"],
  ["Aibonito", "aibonito"], ["Anasco", "anasco"], ["Arecibo", "arecibo"], ["Arroyo", "arroyo"],
  ["Barceloneta", "barceloneta"], ["Barranquitas", "barranquitas"], ["Bayamon", "bayamon"], ["Cabo Rojo", "cabo-rojo"],
  ["Caguas", "caguas"], ["Camuy", "camuy"], ["Canovanas", "canovanas"], ["Carolina", "carolina"],
  ["Catano", "catano"], ["Cayey", "cayey"], ["Ceiba", "ceiba"], ["Ciales", "ciales"],
  ["Cidra", "cidra"], ["Coamo", "coamo"], ["Comerio", "comerio"], ["Corozal", "corozal"],
  ["Culebra", "culebra"], ["Dorado", "dorado"], ["Fajardo", "fajardo"], ["Florida", "florida"],
  ["Guanica", "guanica"], ["Guayama", "guayama"], ["Guayanilla", "guayanilla"], ["Guaynabo", "guaynabo"],
  ["Gurabo", "gurabo"], ["Hatillo", "hatillo"], ["Hormigueros", "hormigueros"], ["Humacao", "humacao"],
  ["Isabela", "isabela"], ["Jayuya", "jayuya"], ["Juana Diaz", "juana-diaz"], ["Juncos", "juncos"],
  ["Lajas", "lajas"], ["Lares", "lares"], ["Las Marias", "las-marias"], ["Las Piedras", "las-piedras"],
  ["Loiza", "loiza"], ["Luquillo", "luquillo"], ["Manati", "manati"], ["Maricao", "maricao"],
  ["Maunabo", "maunabo"], ["Mayaguez", "mayaguez"], ["Moca", "moca"], ["Morovis", "morovis"],
  ["Naguabo", "naguabo"], ["Naranjito", "naranjito"], ["Orocovis", "orocovis"], ["Patillas", "patillas"],
  ["Penuelas", "penuelas"], ["Ponce", "ponce"], ["Quebradillas", "quebradillas"], ["Rincon", "rincon"],
  ["Rio Grande", "rio-grande"], ["Sabana Grande", "sabana-grande"], ["Salinas", "salinas"], ["San German", "san-german"],
  ["San Juan", "san-juan"], ["San Lorenzo", "san-lorenzo"], ["San Sebastian", "san-sebastian"], ["Santa Isabel", "santa-isabel"],
  ["Toa Alta", "toa-alta"], ["Toa Baja", "toa-baja"], ["Trujillo Alto", "trujillo-alto"], ["Utuado", "utuado"],
  ["Vega Alta", "vega-alta"], ["Vega Baja", "vega-baja"], ["Vieques", "vieques"], ["Villalba", "villalba"],
  ["Yabucoa", "yabucoa"], ["Yauco", "yauco"]
];

const makeMunicipalityPages = ([name, slug]) => ([
  makeSpanishPage({
    slug: `comparables-${slug}`,
    path: `/es/comparables-${slug}`,
    priority: ["san-juan", "caguas", "bayamon", "guaynabo", "carolina", "ponce", "mayaguez", "dorado", "humacao", "arecibo"].includes(slug) ? 0.78 : 0.62,
    title: `Comparables en ${name}, Puerto Rico`,
    description: `Analiza ventas cerradas y comparables en ${name} con filtros, mapas, CRIM, riesgos y exportacion en CASADATA.`,
    eyebrow: `COMPARABLES EN ${name.toUpperCase()}`,
    h1: `Comparables y ventas cerradas en ${name}, Puerto Rico`,
    intro: [
      `Analiza ventas cerradas y comparables en ${name} usando CASADATA. Filtra por zona, precio, fecha, tamano de estructura, tamano de solar y tipo de propiedad para sustentar decisiones de compra, venta, tasacion o inversion.`
    ],
    sections: [
      {
        heading: `Datos disponibles para ${name}`,
        items: [
          "Ventas cerradas residenciales.",
          "Comparables multifamiliares, solares y comerciales cuando aplican.",
          "Datos de comprador y vendedor para PlusMAX.",
          "CRIM/catastro y estimado de contribuciones cuando estan disponibles.",
          "Propiedades reposeidas, refinanciadas e inundables.",
          "Exportacion CSV compatible con Excel para analisis profesional."
        ]
      },
      {
        heading: "Usos comunes",
        items: [
          "Verificar si una propiedad esta sobrevalorada.",
          "Sustentar una oferta de compra.",
          "Preparar una opinion de precio para un cliente.",
          "Comparar ventas reales antes de listar una propiedad."
        ]
      },
      {
        heading: `Resumen de mercado en ${name}`,
        body: [`CASADATA permite analizar ventas cerradas por fecha, tamano, precio y tipo de propiedad en ${name}.`]
      },
      limitationSection
    ],
    faqs: coreFaqs.slice(0, 4),
    primaryCta: `Buscar comparables en ${name}`,
    primaryHref: `/?municipio=${encodeURIComponent(name)}&src=seo_municipio`,
    secondaryCta: "Ver planes",
    secondaryHref: "/planes"
  }),
  makeSpanishPage({
    slug: `ventas-cerradas-${slug}`,
    path: `/es/ventas-cerradas-${slug}`,
    priority: 0.58,
    title: `Ventas cerradas en ${name}, Puerto Rico`,
    description: `Explora ventas cerradas en ${name} para entender precios, liquidez, comparables y tendencias con CASADATA.`,
    eyebrow: `VENTAS CERRADAS EN ${name.toUpperCase()}`,
    h1: `Ventas cerradas en ${name}, Puerto Rico`,
    intro: [
      `CASADATA ayuda a analizar ventas cerradas en ${name} para entender precios reales, actividad de mercado, precio por pie cuadrado y comparables relevantes.`
    ],
    sections: [
      {
        heading: "Que puedes revisar",
        items: [
          "Precio de venta y fecha de venta.",
          "Tamano de estructura y tamano de terreno.",
          "Precio por pie cuadrado.",
          "Mapa de ventas cercanas.",
          "Datos CRIM/catastro y documentos disponibles cuando existan.",
          "Indicadores de reposeidas, refinanciadas e inundabilidad."
        ]
      },
      limitationSection
    ],
    faqs: coreFaqs.slice(0, 3),
    primaryCta: `Analizar ventas en ${name}`,
    primaryHref: `/?municipio=${encodeURIComponent(name)}&src=seo_ventas_municipio`,
    secondaryCta: "Ver planes",
    secondaryHref: "/planes"
  })
]);

const municipalityPages = municipalities.flatMap(makeMunicipalityPages);

const extraSpanishPages = [
  methodologyPage,
  comparisonPage,
  ...reportPages,
  ...educationPages
];

const SEO_PAGES = [...corePages, ...topicPages, ...searchIntentPages, ...extraSpanishPages, ...municipalityPages];

const normalizePath = (path = "/") => {
  const clean = String(path || "/").split("?")[0].split("#")[0].toLowerCase().replace(/\/+$/, "");
  return clean || "/";
};

const SEO_PAGE_BY_PATH = SEO_PAGES.reduce((acc, page) => {
  acc[normalizePath(page.path)] = page;
  return acc;
}, {});

const getSeoPageByPath = (path) => SEO_PAGE_BY_PATH[normalizePath(path)] || null;

const getCanonicalUrl = (page) => makeUrl(page.path);

const getAlternateUrls = (page) => {
  const alternates = page && page.alternates ? page.alternates : {};
  return Object.entries(alternates).map(([hreflang, path]) => ({
    hreflang,
    href: makeUrl(path)
  }));
};

const getPrimaryLanguageName = (page) => languageLabel[page.language] || page.language || "Spanish";

const getOfferCatalog = () => ({
  "@type": "OfferCatalog",
  name: "Planes de CASADATA",
  itemListElement: [
    {
      "@type": "Offer",
      name: "Gratis / Base",
      price: String(pricing.base),
      priceCurrency: "USD",
      description: "Acceso base para explorar CASADATA."
    },
    {
      "@type": "Offer",
      name: "Pase 72h",
      price: String(pricing.pass72),
      priceCurrency: "USD",
      description: "Acceso de 72 horas a CASADATA. Pago único, no recurrente."
    },
    {
      "@type": "Offer",
      name: "PlusMAX Mensual",
      price: String(pricing.plusMaxMonthly),
      priceCurrency: "USD",
      description: "Acceso mensual a comparables, mapas, analisis avanzado, datos adicionales y exportaciones."
    },
    {
      "@type": "Offer",
      name: "PlusMAX Anual",
      price: String(pricing.plusMaxYearly),
      priceCurrency: "USD",
      description: "Acceso anual a CASADATA PlusMAX."
    },
    {
      "@type": "Offer",
      name: "PlusMAX Pro Mensual",
      price: String(pricing.plusMaxProMonthly),
      priceCurrency: "USD",
      description: "Nivel profesional: informe PDF de comparables con tu nombre y marca, historial de informes, áreas guardadas con resumen al iniciar sesión y chat de análisis con IA."
    },
    {
      "@type": "Offer",
      name: "PlusMAX Pro Anual",
      price: String(pricing.plusMaxProYearly),
      priceCurrency: "USD",
      description: "Acceso anual a CASADATA PlusMAX Pro."
    }
  ]
});

export {
  SITE_ORIGIN,
  SEO_PAGES,
  SEO_PAGE_BY_PATH,
  normalizePath,
  getSeoPageByPath,
  getCanonicalUrl,
  getAlternateUrls,
  getPrimaryLanguageName,
  getOfferCatalog
};
